export default __webpack_public_path__ + "static/media/one-point-jump.8afb0490.md";